<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <card>
            <template slot="header">
              <h4 class="card-title">NYI</h4>
              <p class="card-category">Not Yet Implemented</p>
            </template>
            Coming Soon!
          </card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
};
</script>
